module.exports = __webpack_public_path__ + "img/21.dba96a93.png";